export default "/img/slide-1.png"